"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSectionContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledSectionContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: ${({ direction }) => (direction ? direction : 'column')}};
  justify-content: ${({ justify }) => (justify ? justify : 'center')}};
  height: ${({ height }) => (height ? height : 'auto')}};
  margin: ${({ margin }) => (margin ? margin : '0')}};
  width: ${({ half }) => (half ? '50%' : '100%')}};
`;
